import { TsDOM as q } from '@/scripts/core/TsDOM'
import { BlogGrid } from '@/scripts/blog/blog-grid'

q.safeDefineElement(BlogGrid)
